// extracted by mini-css-extract-plugin
module.exports = {"app":"styles__app__3UZqj"};